import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getFn = () => restHelpers.withBearer.get(`${K.API_URL}/dealers/find-one`, {});

export default {
  get: getFn
};



// WEBPACK FOOTER //
// ./src/services/dealer.js